import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { PayableTypeSchema, StoreConnectedAccountRequestSchema } from '~/services/api/generated'
import { strictify } from '~/utils/strictify'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({
  enums: [{ field: 'payable_type', options: PayableTypeSchema.options }],
  int: ['business_profile_brand_id', 'payable_id']
})

const PaymentOnboardingStoreSchema = strictify(StoreConnectedAccountRequestSchema)

export const PaymentOnboardingStore = (_context: NoContext = {}) =>
  z.preprocess(normalize, PaymentOnboardingStoreSchema)
